import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Replenishments_ds_location_replenishment_editorService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { locationReplenishmentId: number }): 
  Promise<{ result: { Id?: number, ComparisonTypeId?: number, LocationId?: number, MaterialId?: number, MaximumPackagedAmount?: number, MaximumPackingId?: number, MinimumPackagedAmount?: number, MinimumPackagingId?: number, OnDemand?: boolean, ReplenishmentPackagedAmount?: number, ReplenishmentPackagingId?: number, SystemTriggered?: boolean, ComparisonType?: { DisplayName?: string }, Location?: { Name?: string }, Material?: { Description?: string, LookupCode?: string, Name?: string } } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.locationReplenishmentId)) {
      missingRequiredInParams.push('\'locationReplenishmentId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Replenishments/datasources/ds_location_replenishment_editor/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      locationReplenishmentId: number    }) {
        if(isNil(inParams.locationReplenishmentId)) {
          return true; 
        }
      return false;
    }
}
